import { GrowthBook } from '@growthbook/growthbook-react';

export const GROWTHBOOK_API_HOST = 'https://cdn.growthbook.io';

// GrowthBook instance
export const growthbookInstance = new GrowthBook({
  apiHost: GROWTHBOOK_API_HOST,
  clientKey: window.REACT_APP_GROWTHBOOK_API_KEY,
  enableDevMode: true,
});
